// Styles
import "vuetify/styles";
// Vuetify
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, fa } from "vuetify/iconsets/fa";

import * as labs from "vuetify/labs/components";
// import * as labs from "vuetify/labs";

const vuetify = createVuetify({
  components: {
    ...labs,
    ...components,
    ...directives
  },
  breakpoint: {
    scrollBarWidth: 16,
    thresholds: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1200,
      xl: 1400
    }
  },
  rtl: false,
  icons: {
    defaultSet: "fa",
    aliases,
    sets: {
      fa
    }
  },

  theme: {
    options: {
      customProperties: true
    },
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#24a1c7",
          secondary: "#011630",
          bluecool200: "#D9D8DA",
          fireaxered100: "#FBFAFB"
        }
      },
      dark: {
        colors: {
          primary: "#F24139",
          secondary: "#403E48",
          bluecool200: "#D9D8DA",
          fireaxered100: "#FBFAFB"
        }
      }
    }
  }
});

export default vuetify;
